var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItalize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7605 9H13.7605L11.5605 19H9.56055L11.7605 9ZM13.4405 5C13.2428 5 13.0494 5.05865 12.885 5.16853C12.7205 5.27841 12.5924 5.43459 12.5167 5.61732C12.441 5.80004 12.4212 6.00111 12.4598 6.19509C12.4983 6.38907 12.5936 6.56725 12.7334 6.70711C12.8733 6.84696 13.0515 6.9422 13.2455 6.98079C13.4394 7.01937 13.6405 6.99957 13.8232 6.92388C14.006 6.84819 14.1621 6.72002 14.272 6.55557C14.3819 6.39112 14.4405 6.19778 14.4405 6C14.4405 5.73478 14.3352 5.48043 14.1477 5.29289C13.9601 5.10536 13.7058 5 13.4405 5Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalize);
export default __webpack_public_path__ + "static/media/italize.042bc51795b74d640c34dc058f7da774.svg";
export { ForwardRef as ReactComponent };